<template>
    <div class="timetable">

        <time-table-header class="timetable-header" v-if="employees.length" v-model="selectedDate"></time-table-header>

        <div v-show="!loading && employees.length" class="timetable-body" :style="mergedStyle">

            <table class="timetable-body-table">

                <thead :style="{ 'left': scrollLeft + 'px' }">
                <tr>
                    <th v-for="employee in employees">
                        <div>
                            <user-image :image="employee.image" :color="employee.color"></user-image>
                            <span class="employee">
                                {{ employee.name }}
                            </span>
                        </div>
                    </th>
                </tr>
                </thead>

                <tbody>
                <row v-for="(time, index) in (rows/4)" :key="index" :time="(startTime  + time) - 1" @create="createAppointment"></row>
                </tbody>

            </table>

            <ul class="timetable-body-hours" :style="{ 'top': scrollTop + 'px' }">
                <li v-for="row in (rows/4)">{{ (startTime + row) - 1 }}</li>
            </ul>

            <appointment :ref="'appointment_' + appointment.id" v-for="(appointment, index) in appointments" :key="index + '_' + appointment.id"
                         v-model="appointments[index]">
            </appointment>

            <task :ref="'task_' + task.id" v-for="(task, index) in tasks" :key="index"
                  :appointment="getAppointment(task)"
                  v-model="tasks[index]">
            </task>

            <div :class="{'timetable-body-timer': true, 'active': timerActive}" :style="{ 'top': timerTop + 'px' }"></div>
        </div>

        <div v-show="loading" class="spinner">
            <div class="spinner-inner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </div>

        <div v-if="!loading && !employees.length" class="timetable-empty">
            <div class="timetable-empty-wrap">
                <h1>
                    {{ $t('message.welcome.welcomeSalonize') }} 🎉
	            </h1>
                <h3>
                    {{ $t('message.welcome.followSteps') }}
	            </h3>
                <p>
                    <div class="margin-bottom-10">
                        {{ $t('message.welcome.firstStep') }}
                    </div>
                    <router-link to="/organization/settings/employees" class="button-full">
                        {{ $t('label.addEmployee') }}
                    </router-link>
                </p>
                <p>
                    <div class="margin-bottom-10">
                        {{ $t('message.welcome.secondStep') }}
                    </div>
                    <router-link to="/organization/settings/services" class="button-full">
                        {{ $t('label.addService') }}
                    </router-link>
                </p>
            </div>
        </div>

        <create-appointment-modal ref="createAppointment"
                                  @created="createdAppointment"
                                  @closed="closedAppointment"></create-appointment-modal>

    </div>
</template>
<script>
  import Vue from 'vue'
  import TimeTableHeader from '@/components/timetable/TimeTableHeader'
  import Appointment from './Appointment'
  import Task from './Task'
  import Row from './Row'
  import TimeTableConst from '@/assets/sass/components/timetable/_variables.scss'
  import CreateAppointmentModal from '@/components/pages/Organization/Table/CreateAppointmentModal'
  import UserImage from '@/components/widgets/UserImageWidget'

  export default {
    name: 'TimeTable',
    provide: {
      eventBus: null
    },
    components: {
      UserImage, TimeTableHeader, Row, Appointment, Task, CreateAppointmentModal
    },
    data: function () {
      return {
        loading: false,
        selectedDate: this.$route.params.date ? this.$moment(this.$route.params.date, 'YYYY-M-D').toDate() : this.$moment.utc().toDate(),
        rows: 96,
        appointments: [],
        tasks: [],
        employees: [],
        weekDay: null,
        margin: [0, 0],
        scrollLeft: TimeTableConst.hoursWidth,
        scrollTop: 0,
        isMobile: this.checkMobile(),
        services: [],
        materials: [],
        timer: null,
        timerTop: 0,
        timerActive: false,
        lastAppointment: null,
        lastTask: null
      }
    },
    created () {
      let self = this
      self.scrollTop = self.hoursTop

      self.resizeEventHandler = function (eventType, value, h, w) {
        self.resizeEvent(eventType, value, h, w)
      }

      self.dragEventHandler = function (eventType, value, x, y) {
        self.dragEvent(eventType, value, x, y)
      }

      self.resizeEventTaskHandler = function (eventType, value, h, w) {
        self.resizeEventTask(eventType, value, h, w)
      }

      self.dragEventTaskHandler = function (eventType, value, x, y) {
        self.dragEventTask(eventType, value, x, y)
      }

      self._provided.eventBus = new Vue()
      self.eventBus = self._provided.eventBus
      self.eventBus.$on('resizeEvent', self.resizeEventHandler)
      self.eventBus.$on('dragEvent', self.dragEventHandler)

      self.eventBus.$on('resizeEventTask', self.resizeEventTaskHandler)
      self.eventBus.$on('dragEventTask', self.dragEventTaskHandler)

      window.addEventListener('scroll', this.scrollHandler)
      window.addEventListener('resize', this.resizeHandler)
      this.getAppointments()

      this.timer = window.setInterval(this.loadTimer, 1000 * 60 * 5)
    },
    beforeDestroy: function () {
      let self = this
      this.eventBus.$off('resizeEvent', self.resizeEventHandler)
      this.eventBus.$off('dragEvent', self.dragEventHandler)

      self.eventBus.$off('resizeEventTask', self.resizeEventTaskHandler)
      self.eventBus.$off('dragEventTask', self.dragEventTaskHandler)

      window.removeEventListener('scroll', this.scrollHandler)
      window.removeEventListener('resize', this.resizeHandler)
      window.clearInterval(this.timer)
    },
    computed: {
      hoursTop () {
        return this.isMobile ? parseInt(TimeTableConst.hoursTopMobile) : parseInt(TimeTableConst.hoursTop)
      },
      startTime () {
        let start = this.weekDay && this.weekDay.start ? this.weekDay.start : 0
        if (start >= 3) {
          start = start - 2
        }
        this.rows = 96 - (start * 4)
        return start
      },
      mergedStyle () {
        let containerHeight = this.rows * parseInt(TimeTableConst.cellHeight)
        let containerWidth = this.employees.length * parseInt(TimeTableConst.cellWidth)
        return {
          height: containerHeight + 'px',
          width: containerWidth + 'px'
        }
      }
    },
    watch: {
      selectedDate () {
        this.$router.push({
          name: 'table',
          params: {date: this.$moment(this.selectedDate).format('YYYY-M-D')}
        })
        this.getAppointments()
        this.loadTimer()
      },
      isMobile () {
        if (this.isMobile) {
          this.scrollTop = this.scrollTop - 60
        } else {
          this.scrollTop = this.scrollTop + 60
        }
      }
    },
    methods: {
      loadTimer () {
        this.timerActive = false
        if (this.$moment(this.selectedDate).isSame(this.$moment(), 'day')) {
          this.timerActive = true

          let hourScale = this.$moment().hour()
          let minuteScale = this.$moment().minutes() / 15
          if (hourScale < this.startTime) {
            minuteScale = 0
            if (this.startTime >= 3) {
              hourScale = 0
            } else {
              hourScale = this.startTime
            }
          } else {
            hourScale = hourScale - this.startTime
          }

          let height = ((hourScale * 4) + minuteScale) * parseInt(TimeTableConst.cellHeight)
          this.timerTop = height
        }
      },
      scrollHandler (e) {
        this.scrollTop = this.hoursTop - (e.target.scrollingElement.scrollTop)
        this.scrollLeft = parseInt(TimeTableConst.hoursWidth) - (e.target.scrollingElement.scrollLeft)
      },
      resizeHandler (e) {
        this.isMobile = this.checkMobile()
      },
      checkMobile () {
        return window.innerWidth < 768
      },
      dragEvent: function (eventName, appointment, previousX, previousY) {
        this.lastAppointment = appointment
        this.lastTask = null
        this.eventBus.$emit('compact')
        if (eventName === 'dragend') {
          this.saveAppointment(appointment)
        }
      },
      resizeEvent: function (eventName, appointment, h, w) {
        this.lastAppointment = appointment
        this.lastTask = null
        this.eventBus.$emit('compact')
        if (eventName === 'resizeend') {
          this.saveAppointment(appointment)
        }
      },
      dragEventTask: function (eventName, currentTask, previousX, previousY) {
        this.lastTask = currentTask
        let appointment = this.getAppointment(currentTask)
        this.lastAppointment = appointment

        this.eventBus.$emit('compactTask')
        if (eventName === 'dragend') {
          this.saveAppointment(appointment)
        }
      },
      resizeEventTask: function (eventName, currentTask, h, w) {
        this.lastTask = currentTask
        let appointment = this.getAppointment(currentTask)
        this.lastAppointment = appointment

        this.eventBus.$emit('compactTask')
        if (eventName === 'resizeend') {
          this.saveAppointment(appointment)
        }
      },
      getAppointments () {
        if (document.scrollingElement.scrollTop) {
          this.$store.commit('SET_TABLE_SCROLL_POSITION', {
            top: document.scrollingElement.scrollTop,
            left: document.scrollingElement.scrollLeft
          })
        }
        this.loading = true
        this.appointments = []
        this.tasks = []
        let selectDate = this.$moment(this.selectedDate).format('YYYY-MM-DD')
        this.$api.get('/v1/appointments?date=' + selectDate).then(response => {
          this.weekDay = response.data.data.weekDay
          this.employees = response.data.data.employees
          this.appointments = this.rebuildAppointments(response.data.data.appointments)
          this.loadTimer()
          this.positionScroll()
          this.loading = false
        }).catch(error => {
          console.error(error)
          this.loading = false
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.somethingWentWrong')
          })
        })
      },
      getAppointment (currentTask) {
        for (let i in this.appointments) {
          let appointment = this.appointments[i]
          for (let j in appointment.tasks) {
            let task = appointment.tasks[j]
            if (task.id === currentTask.id) {
              return this.appointments[i]
            }
          }
        }
        return null
      },
      getAppointmentIndex (appointment) {
        let index = -1
        for (let i in this.appointments) {
          if (this.appointments[i].id === appointment.id) {
            index = i
            break
          }
        }
        return index
      },
      getTaskIndex (task) {
        let index = -1
        for (let i in this.tasks) {
          if (this.tasks[i].id === task.id) {
            index = i
            break
          }
        }
        return index
      },
      saveAppointment (appointment) {
        this.$api.post('/v1/appointments/' + appointment.id, appointment).catch(error => {
          console.error(error)
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.somethingWentWrong')
          })
        })
      },
      createAppointment (data) {
        data.date = this.$moment(this.selectedDate).format('YYYY-MM-DD')
        this.$store.commit('SET_TABLE_SCROLL_POSITION', {
          top: document.scrollingElement.scrollTop,
          left: document.scrollingElement.scrollLeft
        })
        this.$parent.locked = true
        this.$refs.createAppointment.show(data)
      },
      createdAppointment (appointment) {
        if (!this.appointmentExists(appointment)) {
          this.$set(this.appointments, this.appointments.length, this.rebuildAppointment(appointment, true))
        }
        this.$parent.locked = false
        this.positionScroll()

        this.lastAppointment = appointment
        this.lastTask = null
      },
      closedAppointment () {
        this.$parent.locked = false
        this.positionScroll()
      },
      positionScroll () {
        Vue.nextTick(() => {
          let scrollPosition = this.$store.state.tableScrollPosition
          if (!scrollPosition && !this.$moment(this.selectedDate).isSame(this.$moment(), 'day')) {
            let y = 6
            let top = Math.round(parseInt(TimeTableConst.cellHeight) * y)
            scrollPosition = {
              top: top,
              left: 0
            }
            this.$store.commit('SET_TABLE_SCROLL_POSITION', scrollPosition)
          } else if (!scrollPosition) {
            let top = this.timerTop - parseInt(document.scrollingElement.offsetHeight / 4)
            scrollPosition = {
              top: top,
              left: 0
            }
            this.$store.commit('SET_TABLE_SCROLL_POSITION', scrollPosition)
          }

          if (scrollPosition) {
            document.scrollingElement.scrollTop = scrollPosition.top
            document.scrollingElement.scrollLeft = scrollPosition.left
          }
        })
      },
      rebuildAppointments (appointments) {
        if (!appointments || appointments.length === 0) {
          return []
        }
        this.tasks = []
        for (let i in appointments) {
          let rebuilded = this.rebuildAppointment(appointments[i], true)
          if (rebuilded) {
            appointments[i] = rebuilded
          }
        }
        return appointments
      },
      rebuildAppointment (appointment, withTaskPush = false) {
        appointment.split = false
        appointment.h = 0
        let previous

        if (!appointment.tasks.length) {
          return null
        }

        for (let t in appointment.tasks) {
          appointment.tasks[t] = this.rebuildTask(appointment.tasks[t])
          if (previous && (appointment.tasks[t].x !== previous.x || (previous.y + previous.h) < appointment.tasks[t].y || previous.y >= appointment.tasks[t].y)) {
            appointment.split = true
          }
          previous = appointment.tasks[t]
          if (withTaskPush) {
            this.$set(this.tasks, this.tasks.length, appointment.tasks[t])
          }
        }
        appointment.x = appointment.tasks[0].x
        appointment.y = appointment.tasks[0].y

        appointment.h = appointment.tasks[0].h
        if (appointment.tasks.length > 1) {
          appointment.h = (appointment.tasks[appointment.tasks.length - 1].y + appointment.tasks[appointment.tasks.length - 1].h) - appointment.tasks[0].y
        }
        return appointment
      },
      rebuildTask (task) {
        let start = task.start
        let end = task.end
        if (start < this.startTime) {
          start = this.startTime
        } else {
          start = start - this.startTime
        }

        if (end < start) {
          end = start + 1
        }

        end = end - this.startTime

        task.x = this.calcX(task.employee)
        task.y = parseFloat(start) * 4
        task.h = (parseFloat(end) * 4) - task.y
        if (task.h < 0) {
          task.h = 1
        }
        return task
      },
      calcX (employee) {
        for (let i in this.employees) {
          if (employee.id === this.employees[i].id) {
            return parseInt(i)
          }
        }
      },
      appointmentExists (appointment) {
        let exists = false
        for (let i in this.appointments) {
          if (this.appointments[i].id === appointment.id) {
            exists = true
            break
          }
        }
        return exists
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/timetable/TimeTable.vue